var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowelOnHanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.937,
    height: 22.424,
    viewBox: "0 0 28.937 22.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.537,9.547v3.619h.531a1.81,1.81,0,1,0,0-3.619Z",
    transform: "translate(-15.942 -6.834)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.631,29.654a2.6,2.6,0,0,1-2.62-2.6v-9.7H8.117V30.909a1.272,1.272,0,0,0,1.3,1.277H22.531a1.292,1.292,0,0,0,1.32-1.277V29.654H13.631Z",
    transform: "translate(-3.042 -9.761)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.968,11.166a1.624,1.624,0,0,0-1.6-1.619H1.809a1.808,1.808,0,1,0,0,3.617H6.37a1.57,1.57,0,0,0,1.6-1.555v-.443Z",
    transform: "translate(0 -6.834)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.366,5.208A1.251,1.251,0,0,0,8.1,6.475h.906A3.471,3.471,0,0,1,12.452,9.94V22.558a1.272,1.272,0,0,0,1.3,1.277H26.864a1.292,1.292,0,0,0,1.321-1.277V7.868a2.664,2.664,0,0,0-2.64-2.66H9.366Z",
    transform: "translate(-3.036 -5.208)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowelOnHanger);
export default __webpack_public_path__ + "static/media/towel-on-hanger.abcd102be8b1f6a53fc714398db6a373.svg";
export { ForwardRef as ReactComponent };